import styled from "styled-components";

export const Menu = styled.div`
    position: fixed;
    z-index: 1000;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0 8px 28px rgba(20,30,50,0.16);
    padding: 6px;
    font-family: Mulish;
`;

export const Item = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    border: none;
    background: transparent;
    text-align: left;
    padding: 8px 10px;
    border-radius: 7px;
    font-family: Mulish;
    font-size: 0.85rem;
    color: #2B3240;
    cursor: pointer;

    &:hover { background: #F3F7FF; }
    &:disabled { color: #B7BEC9; cursor: not-allowed; }
    &:disabled:hover { background: transparent; }
`;

export const Icon = styled.span`
    display: inline-flex;
    font-size: 1rem;
    color: inherit;
`;
